export default __webpack_public_path__ + "static/media/placeholder.6003eecf.svg";